<div class="app-sessions">
  <mat-card>
    <form [formGroup]="settingsForm" class="grid">
      <!------ password section ------>
      <h2 class="column-unique" [translate]="'parameters/sessions/password'"></h2>

      <p class="column-unique" [translate]="'parameters/sessions/password/notice'"></p>

      <!-- min char -->
      <mat-checkbox class="column-1" disabled checked>
        <!-- checkbox just decoration #4755 -->
        <span [translate]="'parameters/sessions/password/nmin-characters'"></span
      ></mat-checkbox>
      <div class="column-2">
        <app-select
          [control]="passwordNminCharactersCtrl"
          labelKey="length"
          [items]="passwordNminCharactersOptions"></app-select>
      </div>

      <!-- max failed attempts -->
      <mat-checkbox class="column-1" disabled checked>
        <!-- checkbox just decoration #4755 -->
        <span [translate]="'parameters/sessions/password/max-failed-attempts'"></span
      ></mat-checkbox>
      <div class="column-2">
        <app-select
          [control]="passwordMaxFailedAttemptsCtrl"
          labelKey="number"
          [items]="passwordMaxFailAttemptsOptions"></app-select>
      </div>

      <!-- special char -->
      <mat-checkbox class="column-1" formControlName="passwordNminSpecialCharactersCheckbox"
        ><span [translate]="'parameters/sessions/password/nmin-special-characters'"></span
      ></mat-checkbox>
      <div class="column-2">
        <app-select
          [control]="passwordNminSpecialCharactersCtrl"
          labelKey="number"
          [items]="passwordNminSpecialCharactersOptions"></app-select>
      </div>

      <!-- lowercase -->
      <mat-checkbox class="column-1" formControlName="passwordHasLowercase"
        ><span [translate]="'parameters/sessions/password/has-lowercase'"></span
      ></mat-checkbox>

      <!-- uppercase -->
      <mat-checkbox class="column-1" formControlName="passwordHasUppercase"
        ><span [translate]="'parameters/sessions/password/has-uppercase'"></span
      ></mat-checkbox>

      <!-- number -->
      <mat-checkbox class="column-1" formControlName="passwordHasNumber"
        ><span [translate]="'parameters/sessions/password/has-number'"></span
      ></mat-checkbox>

      <!-- obviously bad -->
      <mat-checkbox class="column-1" formControlName="passwordIsObviouslyBad"
        ><span [translate]="'parameters/sessions/password/is-obviously-bad'"></span
      ></mat-checkbox>

      <!-- no reuse -->
      <mat-checkbox class="column-1" formControlName="passwordNoReuseNPreviousCheckbox"
        ><span [translate]="'parameters/sessions/password/no-reuse'"></span
      ></mat-checkbox>
      <div class="column-2">
        <app-select
          [control]="passwordNoReuseNPreviousCtrl"
          labelKey="number"
          [items]="passwordNoReuseNPreviousOptions"></app-select>
      </div>

      <!-- month duration -->
      <mat-checkbox class="column-1" formControlName="passwordMaxMonthDurationCheckbox"
        ><span [translate]="'parameters/sessions/password/max-duration'"></span
      ></mat-checkbox>
      <div class="column-2">
        <app-select
          [control]="passwordMaxMonthDurationCtrl"
          labelKey="duration"
          [items]="passwordMaxMonthDurationOptions"></app-select>
      </div>

      <!------ login section ------>
      <h2 class="column-unique" [translate]="'parameters/sessions/login'"></h2>

      <!-- ip filters -->
      <p class="column-unique" [translate]="'parameters/sessions/filtering-by-ip'"></p>

      <div class="column-unique">
        <p
          *ngIf="!ipFilters.length; else ipFiltersList"
          class="no-margin"
          [translate]="'parameters/sessions/filtering-by-ip/none'"></p>
        <ng-template #ipFiltersList>
          <mat-chip-list>
            <mat-chip *ngFor="let ipFilter of ipFilters" (removed)="deleteIpFilter(ipFilter)">
              <div *ngIf="ipFilter.from === ipFilter.to">{{ ipFilter.from }}</div>
              <div *ngIf="ipFilter.from !== ipFilter.to">
                <span [translate]="'parameters/sessions/add_ip/from'"></span> {{ ipFilter.from }}
                <span [translate]="'parameters/sessions/add_ip/to'"></span> {{ ipFilter.to }}
              </div>
              <button matChipRemove>
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          </mat-chip-list>
        </ng-template>
        <button mat-flat-button color="accent" type="button" class="add-ip-filter" (click)="addIpFilter()">
          <span [translate]="'parameters/sessions/add_ip_range'"></span>
        </button>
      </div>

      <!------ logout section ------>
      <h2 class="column-unique" [translate]="'parameters/sessions/logout'"></h2>

      <!-- move to pending -->
      <p class="column-1" [translate]="'parameters/sessions/move-to-pending-upon-disconnect'"></p>
      <div class="column-2 move-to-pending">
        <app-select
          [control]="moveToPendingUponDisconnectCtrl"
          labelKey="action"
          [items]="moveToPendingOptions"></app-select>
      </div>
    </form>
  </mat-card>
</div>

<!-- modal add ip range -->
<ng-template #addIpFilterModalTemplateRef>
  <div class="app-sessions">
    <form [formGroup]="ipFilterForm" class="ip-filter-modal">
      <mat-form-field>
        <mat-label [translate]="'parameters/sessions/add_ip/from'"></mat-label>
        <input matInput formControlName="from" placeholder="{{ ipPlaceholderLabel }}" />
        <mat-hint [translate]="'parameters/sessions/add_ip/must_enter_valid_ip_address'"></mat-hint>
        <mat-error [translate]="'parameters/sessions/add_ip/must_enter_valid_ip_address'"></mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label [translate]="'parameters/sessions/add_ip/to'"></mat-label>
        <input matInput formControlName="to" placeholder="{{ ipPlaceholderLabel }}" />
        <mat-hint [translate]="'parameters/sessions/add_ip/must_enter_valid_ip_address'"></mat-hint>
        <mat-error [translate]="'parameters/sessions/add_ip/must_enter_valid_ip_address'"></mat-error>
      </mat-form-field>
    </form>
  </div>
</ng-template>
